export default function getIdentifier() {
    const urlParams = new URLSearchParams(window.location.search);
    let identifier: string | null = null;
    const hasUrlIdentifier = urlParams.has('identifier');
    const urlIdentifier = urlParams.get('identifier');

    // Query param identifier always has priority; localStorage is fallback-only.
    if (!hasUrlIdentifier) {
        const storageIdentifier = localStorage.getItem('identifier');
        if (storageIdentifier) {
            //set urlIdentifier
            identifier = storageIdentifier;
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.set('identifier', storageIdentifier);
            window.history.replaceState({}, '', newUrl.toString());
        }
    } else {
        identifier = urlIdentifier;
        if (identifier) {
            localStorage.setItem('identifier', identifier);
        }
    }

    if (!identifier) {
        throw new Error('Identifier not found in URL parameters or local storage');
    }
    return identifier;
}
